export const siteStorageName = "crunchorder-signup";

const loadStorage = () => {
  try {
    let serializedState = localStorage.getItem(siteStorageName);

    if (serializedState === null) {
      return undefined;
    }

    return serializedState ? JSON.parse(serializedState) : serializedState;
  } catch (e) {
    return undefined;
  }
};

const commitToStorage = (storageobject: any) => {
  try {
    let serializedState = JSON.stringify(storageobject, function replacer(key, value) {
      return value;
    });
    localStorage.setItem(siteStorageName, serializedState);
  } catch (e) {}
};

const getFromLocalStorage = (key: string) => {
  let persistedState = loadStorage();
  return persistedState !== undefined ? persistedState[key] : undefined;
};

const saveToLocalStorage = (key: string, value: string) => {
  let persistedState = loadStorage();
  if (persistedState === undefined) {
    persistedState = {};
  }
  persistedState[key] = value;
  commitToStorage(persistedState);
};

const removeFromLocalStorage = (key: string) => {
  let persistedState = loadStorage();
  if (persistedState !== undefined) {
    delete persistedState[key];
    commitToStorage(persistedState);
    return true;
  } else {
    return false;
  }
};

const clearAllLocalStorage = () => {
  let persistedState = {};
  commitToStorage(persistedState);
};

export const localStore = { get: getFromLocalStorage, save: saveToLocalStorage, remove: removeFromLocalStorage, clar: clearAllLocalStorage };
